var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.579 0 0 4.53095 0 9.89507C0 15.2592 4.579 19.7901 10 19.7901C15.421 19.7901 20 15.2592 20 9.89507C20 4.53095 15.421 0 10 0ZM10 4.94753C11.727 4.94753 13 6.20619 13 7.91605C13 9.62592 11.727 10.8846 10 10.8846C8.274 10.8846 7 9.62592 7 7.91605C7 6.20619 8.274 4.94753 10 4.94753ZM4.894 14.617C5.791 13.3108 7.287 12.4401 9 12.4401H11C12.714 12.4401 14.209 13.3108 15.106 14.617C13.828 15.9706 12.015 16.8216 10 16.8216C7.985 16.8216 6.172 15.9706 4.894 14.617Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5d674dd0c2b0d7f18c021dbfee6157ec.svg";
export { ForwardRef as ReactComponent };